import type { RxJsonSchema } from 'rxdb';
import type { SettingDocType } from '../types/setting';

export const settingSchema: RxJsonSchema<SettingDocType> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    key: { type: 'string', maxLength: 100 },
    value: { type: 'object' },
    category: { type: 'string', maxLength: 50 },
    updatedAt: { type: 'string' },
  },
  required: ['id', 'key', 'updatedAt'],
  indexes: ['key', 'category'],
};
